<template>
    <v-container fluid>
        <h1>Statistiques de suivi des utilisateurs ou des dossiers</h1>
        <v-divider class="my-3" />

        <!-- <h2 class="mt-5">Général</h2> -->
        <!-- <v-layout align-center>
            <v-row class="justify-center">
                <v-col cols="3" class="px-0 py-0 d-flex align-center">
                    <SingleDataCard
                        title="Nombre d'actions sur les documents"
                        icon="folder"
                        :value="generalDocsValues.countDocuments"
                        color="green"
                        style="margin: 0 !important;"
                    ></SingleDataCard>
                </v-col>
                <v-col cols="3" class="px-0 py-0 d-flex align-center">
                    <SingleDataCard
                        title="Durée moyenne des actions sur les documents"
                        icon="folder"
                        :value="getDuration(generalDocsValues.avgDurationDocuments)"
                        :unit="'s'"
                        color="yellow"
                    ></SingleDataCard>
                </v-col>
                <v-col cols="3" class="px-0 py-0 d-flex align-center">
                    <SingleDataCard
                        title="Nombre d'actions sur les reconciliations"
                        icon="folder"
                        :value="generalDocsValues.countReconciliations"
                        color="green"
                    ></SingleDataCard>
                </v-col>
                <v-col cols="3" class="px-0 py-0 d-flex align-center">
                    <SingleDataCard
                        title="Durée moyenne des actions sur les reconciliations"
                        icon="folder"
                        :value="getDuration(generalDocsValues.avgDurationReconciliations)"
                        :unit="'s'"
                        color="yellow"
                    ></SingleDataCard>
                </v-col>
                <v-col cols="3" class="px-0 py-0 d-flex align-center">
                    <SingleDataCard
                        title="Nombre d'actions sur la révison"
                        icon="folder"
                        :value="generalDocsValues.countAuditChecks"
                        color="green"
                    ></SingleDataCard>
                </v-col>
                <v-col cols="3" class="px-0 py-0 d-flex align-center">
                    <SingleDataCard
                        title="Durée moyenne des actions sur la révison"
                        icon="folder"
                        :value="getDuration(generalDocsValues.avgDurationAuditChecks)"
                        :unit="'s'"
                        color="yellow"
                    ></SingleDataCard>
                </v-col>
                <v-col cols="3" class="px-0 py-0 d-flex align-center">
                    <SingleDataCard
                        title="Nombre d'actions sur les Z de caisse"
                        icon="folder"
                        :value="generalDocsValues.countZtills"
                        color="green"
                    ></SingleDataCard>
                </v-col>
                <v-col cols="3" class="px-0 py-0 d-flex align-center">
                    <SingleDataCard
                        title="Durée moyenne des actions sur les Z de caisse"
                        icon="folder"
                        :value="getDuration(generalDocsValues.avgDurationZtills)"
                        :unit="'s'"
                        color="yellow"
                    ></SingleDataCard>
                </v-col>
            </v-row>
        </v-layout> -->
        <!-- <v-flex xs3 sm4 md3>
                <SingleDataCard
                    title="Durée moyenne pour validation d'une reconciliation"
                    icon="folder"
                    :value="generalDocsValues.avgDurationReconciliations"
                    color="yellow"
                    :unit="'s'"
                ></SingleDataCard>
            </v-flex> -->
        <!-- <v-divider class="my-3"></v-divider> -->
        <!-- <v-layout align-center> -->
        <v-row>
            <v-col>
                <v-row class="justify-center">
                    <!-- <v-col cols="1"></v-col> -->
                    <v-col>
                        <v-select
                            v-model="mode"
                            :items="modes"
                            label="Mode"
                            item-value="value"
                            hide-details
                            :item-title="(item) => item.text"
                        >
                        </v-select>
                    </v-col>
                    <!-- user -->
                    <v-col v-if="mode === 'user'">
                        <v-combobox
                            v-model="selectedUsers"
                            :items="users"
                            label="Utilisateurs"
                            item-value="value"
                            multiple
                            dense
                            chips
                            outlined
                            hide-details
                            :item-title="(item) => item.key"
                            ><template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 3">
                                    <span>{{ item.key }}</span>
                                </v-chip>
                                <span v-if="index == 3" class="grey--text caption"
                                    >(+{{ selectedUsers.length - 3 }} others)</span
                                >
                            </template>
                        </v-combobox>
                    </v-col>
                    <v-col v-if="mode === 'user'">
                        <v-combobox
                            v-model="filterCompany"
                            :items="allAvailableCompanies"
                            label="Société"
                            item-value="value"
                            dense
                            outlined
                            hide-details
                            :item-title="(item) => item.key"
                        >
                        </v-combobox>
                    </v-col>
                    <!-- company -->
                    <v-col v-if="mode === 'company'">
                        <v-combobox
                            v-model="selectedCompanies"
                            :items="allAvailableCompanies"
                            label="Société"
                            item-value="value"
                            multiple
                            chips
                            dense
                            outlined
                            hide-details
                            :item-title="(item) => item.key"
                            ><template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 3" dense>
                                    <span>{{ item.key }}</span>
                                </v-chip>
                                <span v-if="index == 3" class="grey--text caption"
                                    >(+{{ selectedCompanies.length - 3 }} others)</span
                                >
                            </template>
                        </v-combobox>
                    </v-col>
                    <v-col v-if="mode === 'company'">
                        <v-combobox
                            v-model="filterUser"
                            :items="users"
                            label="Utilisateur"
                            item-value="value"
                            dense
                            outlined
                            hide-details
                            :item-title="(item) => item.key"
                        >
                        </v-combobox>
                    </v-col>
                    <v-col v-if="companyId && mode === 'company'">
                        <ossAccountingPeriodSelector
                            v-model="accountingPeriod"
                            :global="false"
                            :companyId="companyId"
                            hide-details
                            dense
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="selectedAction"
                            :items="actionUserActivity"
                            label="Action utilisateur"
                            item-value="value"
                            multiple
                            chips
                            hide-details
                            :item-title="(item) => item.key"
                            ><template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 2">
                                    <span>{{ item.key }}</span>
                                </v-chip>
                                <span v-if="index == 2" class="grey--text caption"
                                    >(+{{ selectedAction.length - 2 }} others)</span
                                >
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="selectedTypeAction"
                            :items="typeActionUserActivity"
                            label="Type de document"
                            item-value="value"
                            multiple
                            chips
                            hide-details
                            :item-title="(item) => item.key"
                            ><template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 2">
                                    <span>{{ item.key }}</span>
                                </v-chip>
                                <span v-if="index == 2" class="grey--text caption"
                                    >(+{{ selectedTypeAction.length - 2 }} others)</span
                                >
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="1">
                        <v-btn-icon @click="clearFilter()" icon="$delete"> </v-btn-icon>
                    </v-col>
                </v-row>
                <!-- Périodes et affichage  -->
                <v-row class="justify-center">
                    <v-col cols="2">
                        <v-select
                            v-model="selectedUnitOfTime"
                            :items="unitOfTime"
                            label="Affichage"
                            item-value="value"
                            hide-details
                            :item-title="(item) => item.key"
                        />
                    </v-col>
                    <v-col cols="2">
                        <ossDatePicker
                            v-model="startDate"
                            label="Début"
                            hide-details
                            :textFieldReadOnly="false"
                        />
                    </v-col>
                    <v-col cols="2">
                        <ossDatePicker
                            v-model="endDate"
                            label="Fin"
                            hide-details
                            :textFieldReadOnly="false"
                        />
                        <!-- <ossDateRangePicker
                                v-bind:begin="startDate"
                                v-bind:end="endDate"
                                :type="'month'"
                                :hideDetails="true"
                                :dense="true"
                                @change-dateRange="onDateRangeChanged"
                            ></ossDateRangePicker> -->
                    </v-col>
                </v-row>

                <!-- Informations companies  -->
                <!-- <v-row v-if="companiesTimeAll.length !== 0">
                        <v-col cols="3">
                            <SingleDataCard
                                title="Nombre total de validations pour les entreprises sélectionnées"
                                icon="folder"
                                :value="companiesTimeAll.nbr"
                                color="blue"
                            ></SingleDataCard>
                        </v-col>
                        <v-col cols="3">
                            <SingleDataCard
                                title="Durée totale de validations des documents pour les entreprises sélectionnées"
                                icon="folder"
                                :value="getCompaniesTimeAll()"
                                color="blue"
                            ></SingleDataCard>
                        </v-col>
                    </v-row> -->
                <v-row class="justify-center">
                    <v-col cols="6">
                        <v-card class="default_card dashboard_card" elevation="0">
                            <v-card-title> Nombre d'actions </v-card-title>
                            <v-container>
                                <bar-chart
                                    :data="dataBarChart(usersDocsValues, 'nbr')"
                                    :options="options"
                                    :height="200"
                                    :key="keyIndex"
                                    v-if="mode === 'user'"
                                />
                            </v-container>
                            <v-container>
                                <bar-chart
                                    :data="dataBarChart(companiesDocsValues, 'nbr')"
                                    :options="options"
                                    :height="200"
                                    :key="keyIndex"
                                    v-if="mode === 'company'"
                                />
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row
            class="mt-4 d-flex align-center justify-center"
            v-if="mode === 'user' && userId && userCompaniesActivities"
        >
            <v-col>
                <pie-chart
                    :data="userCompaniesActivities"
                    :options="{
                        plugins: { legend: { display: true, position: 'bottom' } },
                        maintainAspectRatio: false,
                        ticks: { min: 0 },
                    }"
                    :height="$vuetify.display.mobile ? 200 : 300"
                />
            </v-col>
        </v-row>

        <v-row
            class="mt-4 d-flex align-center justify-center"
            v-if="mode === 'company' && companyId && companyUsersActivities"
        >
            <v-col>
                <pie-chart
                    :data="companyUsersActivities"
                    :options="{
                        plugins: { legend: { display: true, position: 'bottom' } },
                        maintainAspectRatio: false,
                        ticks: { min: 0 },
                    }"
                    :height="$vuetify.display.mobile ? 200 : 300"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="totalTime">
                {{ formatTotalTime }}
            </v-col>
        </v-row>

        <div v-if="activities.length">
            <v-sheet tile height="54" class="d-flex justify center">
                <v-toolbar flat>
                    <!-- <v-btn-icon
                        icon="$oss-chevron-left"
                        class="ma-2"
                        @click="$refs.calendar.prev()"
                    /> -->
                    <!-- <v-select
                v-model="type"
                :items="types"
                dense
                outlined
                hide-details
                class="ma-2"
                label="type"
                ></v-select>
                <v-select
                v-model="mode"
                :items="modes"
                dense
                outlined
                hide-details
                label="event-overlap-mode"
                class="ma-2"
                ></v-select> -->
                    <!-- <v-select
                v-model="weekday"
                :items="weekdays"
                dense
                outlined
                hide-details
                label="weekdays"
                class="ma-2"
                ></v-select> -->
                    <!-- <v-spacer></v-spacer> -->
                    <!-- <v-btn-icon
                        icon="$oss-chevron-right"
                        class="ma-2"
                        @click="$refs.calendar.next()"
                    /> -->
                    <!-- <v-toolbar-title v-if="$refs.calendar">
                        {{ $refs.calendar.title }}
                    </v-toolbar-title> -->
                    <v-select-filled
                        v-model="type"
                        :items="types"
                        hide-details
                        label="type"
                        class="ml-2"
                    />
                    <v-select-filled
                        v-model="mergeDelta"
                        :items="mergeDeltas"
                        outlined
                        hide-details
                        label="Ecart de fusion"
                        class="ml-2"
                    />
                </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
                <v-calendar
                    ref="calendar"
                    v-model="focus"
                    :color="'secondary'"
                    :events="activities"
                    :view-mode="type"
                >
                </v-calendar>
            </v-sheet>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { User } from "../store/store";
import gql from "graphql-tag";

import { Apollo } from "@/decorators";
import SingleDataCard from "../components/cards/SingleDataCard.vue";

import USERS from "../graphql/user/PartOfCompanyUsers2.gql";
// import USERS_ACTIVITIES_GENERAL from "../graphql/usersActivities/UsersActivitiesGeneral.gql"
import USERS_ACTIVITIES_TIME from "../graphql/usersActivities/UsersActivitiesTime.gql";
import COMPANIES_ACTIVITIES_TIME from "../graphql/usersActivities/CompaniesActivitiesTime.gql";
// import COMPANIES_ACTIVITIES_TIME_ALL from "../graphql/usersActivities/CompaniesActivitiesTimeAll.gql"
// import MIN_MAX_ACTIVITIES_DATE from "../graphql/usersActivities/MinMaxActivitiesDate.gql"

import { Bar as BarChart, Pie as PieChart } from "vue-chartjs";

import { chartColors } from "../../../backend/src/common/chart/graphServices";
import { getUserDisplayName } from "../services/userServices";

import ossAccountingPeriodSelector from "./ossComponents/ossAccountingPeriodSelector.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        BarChart,
        PieChart,
        SingleDataCard,
        ossAccountingPeriodSelector,
    },
})
export class UsersActivities extends Vue {
    mode: string = "company";
    modes = [
        { text: "Dossier", value: "company" },
        { text: "Utilisateur", value: "user" },
    ];
    selectedUsers = [];
    selectedCompanies = [];

    filterCompany = null;
    filterUser = null;

    usersAveragesDocs: Array<any> = [];

    loading = false;

    keyIndex: number = 0;

    accountingPeriod = {
        id: "",
        start: "",
        end: "",
        amountSubsciption: 0,
    };

    startDate = moment().startOf("year").format();
    endDate = moment().format();

    unitOfTime: Array<any> = [
        { key: "Total", value: "Total" },
        { key: "Temporel / par mois", value: "TempMonth" },
        { key: "Temporel / par semaine", value: "TempWeek" },
    ];

    actionUserActivity: Array<any> = [
        { key: "Validation", value: "VALIDATE" },
        { key: "Création", value: "CREATE" },
        { key: "Mise à jour", value: "UPDATE" },
        { key: "Suppression", value: "DELETE" },
        { key: "Tagging", value: "TAG" },
        { key: "Supervision", value: "REVIEW" },
    ];

    typeActionUserActivity: Array<any> = [
        { key: "Documents", value: "DOCUMENT" },
        { key: "Réconciliations", value: "RECONCILIATION" },
        { key: "Z de caisses", value: "ZTILL_RECEIPT" },
        { key: "Note de frais", value: "EXPENSE_REPORT" },
        { key: "TVA", value: "VAT" },
        { key: "Révision", value: "AUDIT_CHECK_RESULT" },
    ];

    selectedAction: Array<string> = [];
    selectedTypeAction: Array<string> = [];
    selectedUnitOfTime = "Total";

    get currentUser(): User {
        return this.$store.state.user;
    }

    getDuration(duration) {
        return moment.duration(duration).asSeconds();
    }

    get selectedUserIds() {
        return this.selectedUsers.map((u) => u.value);
    }

    get selectedCompanyIds() {
        return this.selectedCompanies.map((c) => c.value);
    }

    // getCompaniesTimeAll() {
    //     return moment(this.companiesTimeAll.totalTime,'hh:mm:ss').format('HH[h] mm[m]')
    // }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                key: company.name,
            });
            companies.sort((a, b) => {
                if (a.key < b.key) return -1;
                if (a.key > b.key) return 1;
                return 0;
            });
        });

        return companies;
    }

    @Watch("mode")
    onModeChanged() {
        if (this.mode === "company") {
            this.selectedUsers = [];
        } else if (this.mode === "user") {
            this.selectedCompanies = [];
        }
    }

    @Watch("companyId")
    onCompanyIdChanged() {
        this.accountingPeriod = null;
    }

    @Watch("accountingPeriod")
    onAccountingPeriodIdChanged() {
        if (this.accountingPeriod) {
            this.startDate = this.accountingPeriod.start;
            this.endDate = moment(this.accountingPeriod.end).isAfter(moment())
                ? moment().format()
                : this.accountingPeriod.end;
            this.focus = [new Date(this.endDate)];
        }
    }

    get companyId() {
        if (this.mode === "company" && this.selectedCompanyIds.length === 1) {
            return this.selectedCompanyIds[0];
        }
        return undefined;
    }

    get userId() {
        if (this.mode === "user" && this.selectedUserIds.length === 1) {
            return this.selectedUserIds[0];
        }
        return undefined;
    }

    get filterCompanyId() {
        return this.filterCompany ? this.filterCompany.value : "";
    }
    get filterUserId() {
        return this.filterUser ? this.filterUser.value : "";
    }

    clearFilter() {
        this.selectedUsers = [];
        this.selectedCompanies = [];
        this.startDate = moment().startOf("year").format();
        this.endDate = moment().format();
        this.selectedAction = [];
        this.selectedTypeAction = [];
        this.filterCompany = null;
        this.filterUser = null;
        // this.companiesTimeAll = {
        //     totalTime:0,
        //     length:0,
        //     nbr:0
        // }
    }

    get availableCompaniesID() {
        const companyListID = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companyListID.push(company.id);
        });
        return companyListID;
    }

    @Apollo({
        query: USERS,
        variables() {
            return {
                // availableCopanies: this.currentUser.allAvailableCompanies.find(x => x.id === this.$route.params.companyId),
                companyId: this.currentUser.company.id,
                email_not: null,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data) {
                    const users = [];
                    data.users.forEach((user) => {
                        users.push({
                            value: user.id,
                            key: getUserDisplayName(user),
                        });
                    });
                    users.sort((a, b) => {
                        if (a.key < b.key) return -1;
                        if (a.key > b.key) return 1;
                        return 0;
                    });
                    this.users = users;
                }
            }
        },
    })
    users: Array<any> = [];

    // @Apollo({
    //     query: USERS_ACTIVITIES_GENERAL,
    //     specificResult({ data, loading, networkStatus }: any) {
    //         this.loading = loading
    //         if (!loading) {
    //             if (data && data.usersActivitiesGeneral) {
    //                 this.generalDocsValues = data.usersActivitiesGeneral
    //             }
    //         }
    //     }
    // })
    // generalDocsValues: any = {}

    // Users activities
    @Apollo({
        query: USERS_ACTIVITIES_TIME,
        variables() {
            return {
                userIds: this.selectedUserIds,
                filterCompanyId: this.filterCompanyId,
                startDate: this.startDate,
                endDate: this.endDate,
                action: this.selectedAction,
                typeAction: this.selectedTypeAction,
                typeOfDisplay: this.selectedUnitOfTime,
            };
        },
        skip() {
            return this.selectedUsers.length === 0;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data && data.usersActivitiesTime) {
                    this.usersDocsValues = data.usersActivitiesTime;
                    this.keyIndex++;
                } else {
                    this.usersDocsValues = [];
                    this.keyIndex++;
                }
            }
        },
    })
    usersDocsValues: any = [];

    // Companies activities
    @Apollo({
        query: COMPANIES_ACTIVITIES_TIME,
        variables() {
            return {
                companyIds: this.selectedCompanyIds,
                filterUserId: this.filterUserId,
                startDate: this.startDate,
                endDate: this.endDate,
                action: this.selectedAction,
                typeAction: this.selectedTypeAction,
                typeOfDisplay: this.selectedUnitOfTime,
            };
        },
        skip() {
            return this.selectedCompanies.length === 0;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data && data.companiesActivitiesTime) {
                    this.companiesDocsValues = data.companiesActivitiesTime;
                    this.keyIndex++;
                } else {
                    this.companiesDocsValues = [];
                    this.keyIndex++;
                }
            }
        },
    })
    companiesDocsValues: Array<any> = [];

    labelChart(fname, list: any) {
        let value;
        if (typeof fname === "string") {
            value = fname;
        } else {
            value = fname.value;
        }
        const index = list.findIndex((x) => x.value === value);
        if (index !== -1) {
            return list[index].key;
        }
        debugger;
        return fname;
    }

    listIds() {
        if (this.selectedCompanies.length !== 0) {
            return this.selectedCompanyIds;
        }
        if (this.selectedUsers.length !== 0) {
            return this.selectedUserIds;
        }
        return null;
    }

    listIdsNames() {
        if (this.selectedCompanies.length !== 0) {
            return this.allAvailableCompanies;
        }
        if (this.selectedUsers.length !== 0) {
            return this.users;
        }
        return null;
    }

    dicoOperationTitles = {
        nbr: "Nombre d'actions",
        time: "Durée moyenne par action",
    };

    dataBarChart(resultQuery: any, operationType: string) {
        const ids: any = this.listIds();
        const idsNames: any = this.listIdsNames();
        let chartData: any;
        if (resultQuery && resultQuery.dataset && ids) {
            const datasetFinal = [];
            // Affichage temporel
            if (this.selectedUnitOfTime !== "Total") {
                const data = JSON.parse(JSON.stringify(resultQuery.dataset));
                for (let comp = 0; comp < ids.length; comp++) {
                    const labelName = this.labelChart(ids[comp], idsNames);
                    const dataset = [];
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].length > 1) {
                            for (let j = 0; j < data[i].length; j++) {
                                if (ids[comp] === data[i][j].id) {
                                    if (data[i][j][operationType]) {
                                        dataset.push(data[i][j][operationType]);
                                    } else {
                                        dataset.push(0);
                                    }
                                }
                            }
                        } else if (
                            data[i].length === undefined &&
                            data[i] &&
                            ids[comp] === data[i].id
                        ) {
                            dataset.push(data[i][operationType]);
                        } else {
                            dataset.push(0);
                        }
                    }
                    datasetFinal.push({
                        label: labelName === undefined ? "Pas de donnée enregistrée" : labelName,
                        data: dataset,
                    });
                }
                chartColors("bar", datasetFinal, "cool");
                chartData = {
                    labels: resultQuery.labels,
                    datasets: datasetFinal,
                };
                // Affichage Total
            } else {
                const data = JSON.parse(JSON.stringify(resultQuery.dataset));
                for (let i = 0; i < data.length; i++) {
                    const labelName = this.labelChart(data[i].fname, idsNames);
                    datasetFinal.push({
                        label: labelName,
                        data: [data[i][operationType]],
                    });
                }

                chartColors("bar", datasetFinal, "cool");
                chartData = {
                    labels: [this.dicoOperationTitles[operationType] || operationType],
                    datasets: datasetFinal,
                };
            }
            return chartData;
        }
        // If no data, return empty object
        chartData = {
            datasets: [],
            labels: [],
        };

        return chartData;
    }

    get options() {
        // let options
        // @ todo Vincent à corriger
        // if (this.typeOfDisplay === "temp") {
        const options = {
            plugins: {
                legend: {
                    position: "bottom",
                    display: true,
                },
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: [
                    {
                        beginAtZero: true,
                    },
                ],
            },
        };
        // } else if (this.typeOfDisplay === "total") {
        //     options = {
        //         legend: {
        //             position: "bottom",
        //             display: true
        //         },
        //         responsive: true,
        //         maintainAspectRatio: false,
        //         ticks: {
        //             min: 0
        //         },
        //         scales: {
        //             xAxes: [{
        //                 ticks: {
        //                     beginAtZero: true
        //                 }
        //             }]
        //         }
        //     };
        // }

        return options;
    }

    convertTime(time: number) {
        let secondes: number = Math.ceil(time / 1000);
        const minutes: number = (secondes - (secondes % 60)) / 60;
        secondes -= 60 * minutes;
        return {
            min: minutes,
            sec: secondes,
        };
    }

    //
    // Pie : user => companies
    //
    @Apollo({
        query: gql`
            query (
                $userId: ID!
                $startDate: DateTime!
                $endDate: DateTime!
                $companyIds: [ID]
                $mergeDelta: Int
            ) {
                userCompaniesActivities(
                    data: {
                        userId: $userId
                        mergeDelta: $mergeDelta
                        startDate: $startDate
                        endDate: $endDate
                        companyIds: $companyIds
                    }
                ) {
                    output
                }
            }
        `,
        skip() {
            return this.mode !== "user" || !this.userId || !this.startDate || !this.endDate;
        },
        variables() {
            return {
                userId: this.userId,
                startDate: this.startDate,
                endDate: this.endDate,
                mergeDelta: this.mergeDelta,
                companyIds: this.filterCompanyId ? [this.filterCompanyId] : undefined,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (data.userCompaniesActivities.output) {
                const datasets = [
                    {
                        data: data.userCompaniesActivities.output.dataset,
                    },
                ];
                chartColors("pie", datasets[0], "cool");
                this.userCompaniesActivities = {
                    labels: data.userCompaniesActivities.output.labels,
                    datasets: datasets,
                };
                this.computeActivities(data.userCompaniesActivities.output.results);
            } else {
                this.userCompaniesActivities = null;
                this.eventResults = null;
            }
        },
    })
    userCompaniesActivities: any = null;

    //
    // Pie : company => user
    //
    @Apollo({
        query: gql`
            query (
                $companyId: ID!
                $startDate: DateTime!
                $endDate: DateTime!
                $userIds: [ID]
                $mergeDelta: Int
            ) {
                companyUsersActivities(
                    data: {
                        companyId: $companyId
                        mergeDelta: $mergeDelta
                        startDate: $startDate
                        endDate: $endDate
                        userIds: $userIds
                    }
                ) {
                    output
                }
            }
        `,
        skip() {
            return this.mode !== "company" || !this.companyId || !this.startDate || !this.endDate;
        },
        variables() {
            return {
                companyId: this.companyId,
                startDate: this.startDate,
                endDate: this.endDate,
                mergeDelta: this.mergeDelta,
                userIds: this.filterUserId ? [this.filterUserId] : undefined,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (data.companyUsersActivities.output) {
                const datasets = [
                    {
                        data: data.companyUsersActivities.output.dataset,
                    },
                ];
                chartColors("pie", datasets[0], "cool");
                this.companyUsersActivities = {
                    labels: data.companyUsersActivities.output.labels,
                    datasets: datasets,
                };
                this.computeActivities(data.companyUsersActivities.output.results);
            } else {
                this.companyUsersActivities = null;
                this.eventResults = null;
            }
        },
    })
    companyUsersActivities: any = null;

    eventResults = null;

    computeActivities(results) {
        this.eventResults = results;
        const activities = [];
        if (results?.length) {
            for (const row of results) {
                for (const event of row.events) {
                    event.title = row.name;
                    event.start = new Date(event.start);
                    event.end = new Date(event.end);
                    event.color = "secondary";
                    activities.push(event);
                }
            }
        }
        this.activities = activities;
        //  this.activities.push({
        //     name: 'toto',
        //     start: moment().format("YYYY-MM-DD HH:mm"),
        //     end: moment().add(1,"hour").format("YYYY-MM-DD HH:mm"),
        //  })
    }

    @Watch("companyId")
    @Watch("userId")
    onSelectionChanged() {
        this.activities = [];
    }

    get totalTime() {
        if (!this.eventResults?.length) return 0;
        let total = 0;
        for (const event of this.eventResults) {
            total += event.duration;
        }
        return total;
    }

    get formatTotalTime() {
        let time = "";
        if (this.totalTime) {
            const hours = Math.trunc(this.totalTime / 60);
            if (hours) {
                time = hours + " heure(s)";
            }
            const diff = this.totalTime - hours * 60;
            if (diff) {
                if (time) time += " et ";
                time += diff + " minute(s)";
            }
        }

        return time;
    }

    //
    // calendar
    //
    focus = [];
    activities = [];
    type = "week";
    types = [
        {
            title: "Mois",
            value: "month",
        },
        {
            title: "Semaine",
            value: "week",
        },
        {
            title: "Jour",
            value: "day",
        },
        // {
        //     value: "4day"
        // }
    ];
    // calendarMode = "stack";
    // calendarModes = ["stack", "column"];
    mergeDelta = 4;
    mergeDeltas = [1, 2, 3, 4, 5, 10, 15, 20, 25, 30, 60];
}

export default toNative(UsersActivities);
</script>
